import { createSelector, createFeatureSelector } from '@ngrx/store';

import { CountryState } from '@models/index';

export const countrySelector = createFeatureSelector<CountryState>('country');
export const getCountrySelector = createSelector(countrySelector, (state: CountryState) => state); 
